import { useState } from 'react';
import { uuid } from '../';
export const useCurrentDocument = () => {
    const { currentDocument } = parent.AliLowCodeEngine.project;
    return currentDocument;
};
export const useCurrentNode = (componentId) => {
    const currentDocument = useCurrentDocument();
    const id = typeof componentId === 'object' ? componentId.componentId : componentId;
    return currentDocument.getNodeById(id);
};
export const useComponentSchema = (componentId) => {
    const currentNode = useCurrentNode(componentId);
    return currentNode.exportSchema();
};
export const matchComponent = (node, name, context) => {
    if (name === '*')
        return true;
    const { componentName } = node;
    if (typeof name === 'function')
        return name(componentName || '', node, context);
    if (Array.isArray(name))
        return name.includes(componentName);
    return componentName === name;
};
export const queryNodesByComponentPath = (node, path) => {
    if (path?.length === 0)
        return [];
    if (path?.length === 1) {
        if (matchComponent(node, path[0])) {
            return [node];
        }
    }
    return matchComponent(node, path[0])
        ? node.children.reduce((buf, child) => {
            return buf.concat(queryNodesByComponentPath(child, path.slice(1)));
        }, [])
        : [];
};
export const findNodeByComponentPath = (node, path) => {
    if (path?.length === 0)
        return;
    if (path?.length === 1) {
        if (matchComponent(node, path[0])) {
            return node;
        }
    }
    if (matchComponent(node, path[0])) {
        for (let i = 0; i < node.children.size; i++) {
            const next = findNodeByComponentPath(node.children.get(i), path.slice(1));
            if (next) {
                return next;
            }
        }
    }
};
export const hasNodeByComponentPath = (node, path) => !!findNodeByComponentPath(node, path);
export const useStableIds = (length = 10) => {
    const [stableIds] = useState(() => {
        const ids = [];
        for (let i = 0; i < length; i++) {
            ids.push(uuid());
        }
        return ids;
    });
    return stableIds;
};
